import { useState, useEffect } from 'react';
import { Modal, Button, Textarea } from '@shared/ui';
import './OrderCancelModal.css';

interface OrderCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void | Promise<void>;
  isLoading?: boolean;
  title?: string;
  confirmButtonText?: string;
  placeholder?: string;
  description?: string;
  reasonRequired?: boolean;
}

export default function OrderCancelModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title = 'Отменить заказ?',
  confirmButtonText = 'Отменить заказ',
  placeholder = 'Причина отмены',
  description = 'Заказ будет отменён, средства вернутся покупателю. Укажите причину — она сохранится в истории.',
  reasonRequired = true,
}: OrderCancelModalProps) {
  const [comment, setComment] = useState('');
  const reason = comment.trim();
  const reasonMissing = reasonRequired && reason.length === 0;

  useEffect(() => {
    if (!isOpen) {
      setComment('');
    }
  }, [isOpen]);

  const handleClose = () => {
    setComment('');
    onClose();
  };

  const handleConfirm = async () => {
    if (reasonMissing) return;
    await onConfirm(reason);
  };

  return (
    <Modal
      size={440}
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
    >
      <div className="order-cancel-modal">
        {description ? (
          <p className="order-cancel-modal__hint">{description}</p>
        ) : null}
        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={placeholder}
          autosize
          minRows={3}
          maxRows={6}
          disabled={isLoading}
          required={reasonRequired}
          className="order-cancel-modal__textarea"
        />
        <div className="order-cancel-modal__actions">
          <Button size="xs" onClick={handleClose} variant="secondary" disabled={isLoading}>
            Назад
          </Button>
          <Button
            size="xs"
            onClick={handleConfirm}
            variant="secondary"
            loading={isLoading}
            disabled={isLoading || reasonMissing}
            className="order-cancel-modal__confirm"
          >
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
